import { render, staticRenderFns } from "./InspectionAnomaliesLabel.vue?vue&type=template&id=286ac63a&scoped=true&functional=true&"
import script from "./InspectionAnomaliesLabel.vue?vue&type=script&lang=ts&"
export * from "./InspectionAnomaliesLabel.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionAnomaliesLabel.vue?vue&type=style&index=0&id=286ac63a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "286ac63a",
  null
  
)

export default component.exports